enum NotificationColors {
  Success = 'success',
  Error = 'error',
  Warning = 'warning'
}

export enum BaseColors {
  Alto = 'alto',
  Amaranth = 'amaranth',
  BlazeOrange = 'blazeOrange',
  Crow = 'crow',
  DodgerBlue = 'dodgerBlue',
  Emperor = 'emperor',
  FrostedMint = 'frostedMint',
  Gallery = 'gallery',
  Ghost = 'ghost',
  Gray = 'gray',
  JungleGreen = 'jungleGreen',
  KleinBlue = 'kleinBlue',
  LinkWater = 'linkWater',
  Manatee = 'manatee',
  Melrose = 'melrose',
  MineShaft = 'mineShaft',
  Orange = 'orange',
  Pampas = 'pampas',
  Pink = 'pink',
  RadicalRed = 'radicalRed',
  Raven = 'raven',
  Scorpion = 'scorpion',
  Shamrock = 'shamrock',
  Silver = 'silver',
  SilverAlto = 'silverAlto',
  SilverChalice = 'silverChalice',
  UnbounceBlue = 'unbounceBlue',
  Varden = 'varden',
  White = 'white',

  Citrus_DEPRECATED = 'citrus_DEPRECATED',
  Fawn_DEPRECATED = 'fawn_DEPRECATED',
  GreenTea_DEPRECATED = 'greenTea_DEPRECATED',
  GullGray_DEPRECATED = 'gullGray_DEPRECATED',
  Heather_DEPRECATED = 'heather_DEPRECATED',
  Hippie_DEPRECATED = 'hippie_DEPRECATED',
  Pink_DEPRECATED = 'pink_DEPRECATED'
}

export const Colors = {
  ...NotificationColors,
  ...BaseColors
};

export type Colors = NotificationColors | BaseColors;

export default Colors;
